module.exports = __webpack_public_path__ + "static/media/edit.06b4858e.svg";